import { categories } from '@/mocks/categories';
import { Link } from 'react-router-dom';

export default function CategoryCards() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            内容分类浏览
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            按分类快速找到您需要的内容，涵盖教程、问答、动态、资源等多个领域
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((category) => (
            <Link
              key={category.id}
              to={`/category/${category.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-xl p-6 hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300 flex-shrink-0">
                  <i className={`${category.icon} text-xl`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-heading text-lg font-semibold text-foreground-900 group-hover:text-primary-700 transition-colors duration-200 mb-1.5">
                    {category.name}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
                    {category.description}
                  </p>
                  <span className="text-xs text-foreground-500 inline-flex items-center">
                    <i className="ri-file-text-line mr-1"></i>
                    {category.articleCount} 篇文章
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}